<div class="ct-container">
  <div class="ct-main-content">
    <div class="customer-title">Dados Pessoais</div>
    <hr/>

    <div>
      <label for="cphone" class="field-label">Celular*</label>
      @if (errorMsgs['phone']) {
        <label for="cphone" class="error-label">{{errorMsgs['phone']}}</label>
      }
      <input
        id="cphone"
        class="form-control"
        type="tel"
        [(ngModel)]="customer.phone"
        mask="(00) 0 0000-0000"
        [dropSpecialCharacters]="true"
        />
    </div>

    <div>
      <label for="cname" class="field-label">Nome*</label>
      @if (errorMsgs['name']) {
        <label for="cname" class="error-label">{{errorMsgs['name']}}</label>
      }
      <input id="cname" class="form-control" type="text" [(ngModel)]="customer.name" (keydown)="checkNameFormat(customer, 'name')"/>
    </div>

    <div>
      <label for="csurname" class="field-label">Sobrenome*</label>
      @if (errorMsgs['surname']) {
        <label for="csurname" class="error-label">{{errorMsgs['surname']}}</label>
      }
      <input id="csurname" class="form-control" type="text" [(ngModel)]="customer.surname" (keydown)="checkNameFormat(customer, 'surname')"/>
    </div>

    <div>
      <label for="cemail" class="field-label">E-mail</label>
      @if (errorMsgs['email']) {
        <label for="cemail" class="error-label">{{errorMsgs['email']}}</label>
      }
      <input id="cemail" class="form-control" type="email" [(ngModel)]="customer.email"/>
    </div>

    <div>
      <input type="radio" [(ngModel)]="mode" id="delivery" name="mode" value="delivery" [disabled]="!deliveryFeeTable">
      <label for="delivery">Delivery</label><br>
      <input type="radio" [(ngModel)]="mode" id="pickup" name="mode" value="pickup">
      <label for="pickup">Vir buscar</label><br>
    </div>

    @if (!deliveryFeeTable || deliveryFeeTable.disabled) {
      <div class="no-dft">
        Entregas temporariamente indisponíveis para estabelecimento.<br/>
        Por favor, faça a retirada presencialmente.
      </div>
    }

    @if (mode == 'delivery') {
      <div class="address-field">
        <label for="caddress" class="field-label">Endereço*</label>
        @if (errorMsgs['address']) {
          <label for="caddress" class="error-label">{{errorMsgs['address']}}</label>
        }
        <textarea id="caddresss" class="form-control" rows="4" [(ngModel)]="customer.address"
          [placeholder]="addressPlaceholder" maxlength="144">
        </textarea>
        <span class="remaining">{{(144 - (customer.address || '').length)}} caracteres restantes</span>
      </div>
    }

    @if (mode == 'delivery' && deliveryFeeTable) {
      <div>
        <label for="ngsdft" class="field-label">Bairro/Região*</label>
        @if (errorMsgs['district']) {
          <label for="ngsdft" class="error-label">{{errorMsgs['district']}}</label>
        }
        <ng-select #ngsdft
          [items]="deliveryFeeTable.tableObj"
          bindLabel="bairro"
          bindValue="bairro"
          [(ngModel)]="customer.district"
          (change)="onDistrictChange($event)"
          (close)="ngsdft.blur()">
        </ng-select>
      </div>
    }

    @if (mode == 'delivery' && selectedDistrict) {
      <div class="delivery-fee">
        <span>Taxa de entrega:</span> &nbsp;
        <span>{{(selectedDistrict.valor | currency:'BRL':'').replace('.',',')}}</span>
      </div>
    }

    <div class="actions">
      <div><button class="btn btn-lg btn-secondary back-button" (click)="back()" [disabled]="sending">Voltar</button></div>
      <div>
        <button class="btn btn-lg btn-primary" (click)="done()"
          [disabled]="sending || !customer.phone || !customer.name || (mode == 'delivery' && (!customer.address || !selectedDistrict || selectedDistrict.bairro.length == 0))">
          @if (!sending) {
            <span>
              Prosseguir
            </span>
          }
          @if (sending) {
            <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
          }
        </button>
      </div>
    </div>
  </div>
</div>